import "react-app-polyfill/ie11";
import "core-js/stable";
import "regenerator-runtime/runtime";
import React, { Suspense } from "react";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import "./i18n";
import Loading from "./Loading";
import { HelmetProvider } from "react-helmet-async";
import { createRoot } from "react-dom/client";
import queryString from "query-string";

const query = queryString.parse(window.location.search);
const accCustId = query["accCustId"];
const container = document.getElementById("root");

import(`./customers/css/${accCustId}.css`);

const root = createRoot(container as HTMLElement);
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <Provider store={store}>
        <HelmetProvider>
          <App accCustId={query["accCustId"]} />
        </HelmetProvider>
      </Provider>
    </Suspense>
  </React.StrictMode>
);
